export default __webpack_public_path__ + "static/media/14_Zajic_polni_www.mezistromy.cz_thumb-min.efa7d450.jpg";